module.exports = __webpack_public_path__ + "img/scopeBG.f7ccad26.jpg";